var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6573 3.31855C7.79435 3.31855 4.47177 12.3427 8.70968 17.6371C10.1815 19.4677 12.2823 20.6855 14.6573 20.6855C16.121 20.6855 17.4919 20.2379 18.6653 19.4597C16.8992 21.0403 14.5565 22 12 22C11.8427 22 11.6774 22 11.5202 21.9879C6.21774 21.7419 2 17.3669 2 12C2 6.47581 6.47581 2 12 2H12.0323C14.5766 2.0121 16.8992 2.97177 18.6613 4.54435C17.4919 3.7621 16.1169 3.31855 14.6573 3.31855ZM18.7621 19.3548C17.1129 20.3508 15.1048 20.3065 13.4395 19.121C15.7056 18.2944 17.379 15.4274 17.379 12C17.379 8.58468 15.7177 5.71774 13.4516 4.87903C15.1371 3.70161 17.129 3.65726 18.8105 4.67742C23.0806 8.65726 23.0645 15.3911 18.7621 19.3548Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpera);
export default __webpack_public_path__ + "static/media/opera.f83ec83f7c2519050f94f61081993dbd.svg";
export { ForwardRef as ReactComponent };